module.exports = __webpack_public_path__ + "static/media/devices_online_dance_workout_classes.2194ae78.webp";